import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { responseToState } from '~/mappers';
import { MasterApi } from '~/api';
export var state = function state() {
	return {
		departments: [],
		idDepartment: null,
		productsType: [],
		province: [],
		idProvince: null,
		idProductType: null,
		products: [],
		idProduct: null,
		districts: [],
		idDistrict: null,
		idTypeOfSolution: null,
		admisionStartDate: '',
		admisionEndDate: '',
		highStartDate: '',
		highEndDate: '',
		dateAdminOrHight: '',
		tableNameMobile: '',
		menuActivatorProcess: false,
		menuActivatorWorked: false
	};
};

export var getters = {
	departments: function departments(state) {
		return state.departments;
	},
	productsType: function productsType(state) {
		return state.productsType;
	},
	province: function province(state) {
		return state.province;
	},
	idDepartment: function idDepartment(state) {
		return state.idDepartment;
	},
	products: function products(state) {
		return state.products;
	},
	menuActivatorProcess: function menuActivatorProcess(state) {
		return state.menuActivatorProcess;
	},
	menuActivatorWorked: function menuActivatorWorked(state) {
		return state.menuActivatorWorked;
	}
};

export var actions = {
	findProductType: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var commit = _ref.commit;
			var productType;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return new MasterApi(this.$axios).findAllProductType();

						case 2:
							productType = _context.sent;

							commit('setProductType', productType);

						case 4:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function findProductType(_x) {
			return _ref2.apply(this, arguments);
		}

		return findProductType;
	}(),
	findProductByType: function () {
		var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, _ref4) {
			var commit = _ref3.commit;
			var productTypeId = _ref4.productTypeId;
			var response, product, filterProduct;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return new MasterApi(this.$axios).findAllProductByType({
								idproducttype: productTypeId || 0
							});

						case 2:
							response = _context2.sent;
							product = responseToState(response, 'IdProduct', 'Name');
							filterProduct = product.filter(function (p) {
								return p.value !== 7 && p.value !== 8;
							});

							commit('setProducts', filterProduct);
							return _context2.abrupt('return', filterProduct);

						case 7:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function findProductByType(_x2, _x3) {
			return _ref5.apply(this, arguments);
		}

		return findProductByType;
	}(),
	findAllDepartment: function () {
		var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
			var commit = _ref6.commit;
			var department;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return new MasterApi(this.$axios).findAllDepartment();

						case 2:
							department = _context3.sent;

							commit('setDepartments', department);

						case 4:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function findAllDepartment(_x4) {
			return _ref7.apply(this, arguments);
		}

		return findAllDepartment;
	}(),
	findProvinceByDepartment: function () {
		var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8, _ref9) {
			var commit = _ref8.commit;
			var departmentId = _ref9.departmentId;
			var response, provinces, idProvince;
			return _regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return new MasterApi(this.$axios).findAllProvinceByDepartament({
								idDepartament: departmentId || 0
							});

						case 2:
							response = _context4.sent;
							provinces = responseToState(response, 'IdProvince', 'Name');
							idProvince = responseToState(response, 'IdProvince');

							commit('setProvince', provinces);
							commit('setIdProvince', idProvince);
							return _context4.abrupt('return', provinces);

						case 8:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, this);
		}));

		function findProvinceByDepartment(_x5, _x6) {
			return _ref10.apply(this, arguments);
		}

		return findProvinceByDepartment;
	}(),
	findDistrictByProvince: function () {
		var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref11, _ref12) {
			var state = _ref11.state,
			    commit = _ref11.commit;
			var departmentId = _ref12.departmentId,
			    provinceId = _ref12.provinceId;
			var response, districts;
			return _regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							if (!(provinceId !== '')) {
								_context5.next = 9;
								break;
							}

							_context5.next = 3;
							return new MasterApi(this.$axios).findAllDistrictByProvince({
								idDepartament: departmentId || 0,
								idProvince: provinceId || 0
							});

						case 3:
							response = _context5.sent;
							districts = responseToState(response, 'IdDistrict', 'Name');

							commit('setDistricts', districts);
							return _context5.abrupt('return', districts || []);

						case 9:
							return _context5.abrupt('return', []);

						case 10:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function findDistrictByProvince(_x7, _x8) {
			return _ref13.apply(this, arguments);
		}

		return findDistrictByProvince;
	}()
};

export var mutations = {
	setProductType: function setProductType(state, productsType) {
		state.productsType = responseToState(productsType, 'IdProductType', 'Name');
	},

	setIdProductType: function setIdProductType(state, val) {
		state.idProductType = val;
	},
	setDepartments: function setDepartments(state, departments) {
		state.departments = responseToState(departments, 'IdDepartament', 'Name');
	},
	setIdDepartment: function setIdDepartment(state, val) {
		state.idDepartment = val;
	},
	setProvince: function setProvince(state, province) {
		state.province = province;
	},
	setDistricts: function setDistricts(state, districts) {
		state.districts = districts;
	},
	setIdDistrict: function setIdDistrict(state, val) {
		state.idDistrict = val;
	},
	setIdProvince: function setIdProvince(state, val) {
		state.idProvince = val;
	},
	setProducts: function setProducts(state, products) {
		state.products = products;
	},
	setIdProduct: function setIdProduct(state, val) {
		state.IdProduct = val;
	},
	setTypeofSolution: function setTypeofSolution(state, idTypeOfSolution) {
		state.idTypeOfSolution = idTypeOfSolution;
	},
	setAdmisionStartDate: function setAdmisionStartDate(state, data) {
		state.admisionStartDate = data || '';
	},
	admisionEndDate: function admisionEndDate(state, data) {
		state.admisionEndDate = data || '';
	},
	setTableNameMobile: function setTableNameMobile(state, data) {
		state.tableNameMobile = data;
	},
	setHighStartDate: function setHighStartDate(state, data) {
		state.highStartDate = data;
	},
	setHighEndDate: function setHighEndDate(state, data) {
		state.highEndDate = data;
	},
	setDate: function setDate(state, data) {
		state.dateAdminOrHight = data;
	},
	setMenuActivatorTableProcess: function setMenuActivatorTableProcess(state, data) {
		state.menuActivatorProcess = data;
	},
	setMenuActivatorTableWorked: function setMenuActivatorTableWorked(state, data) {
		state.menuActivatorWorked = data;
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/store/dashboard/filters.js
// module id = ./src/store/dashboard/filters.js
// module chunks = 34